import { send } from '@interlayer/js/hooks/socket';

export const changeEmail = ({ email, errorLevel = 1, changeTimestamp }) => send({
    ID: 33045,
    description: 'Update player info',
    responses: [33006, 31008],
    changeTimestamp,
    dataMap: {
        email
    },
    errorLevel
}, true);

export const changeUserContactPreferences = contactPreferences => send({
    ID: 35513,
    description: 'Set user contact preferences',
    responses: [35514, 35515],
    contactPreferences,
    errorLevel: 1
}, true);
